export const environment = {
  apiUrl: 'http://192.168.1.33:8086',
  apiVersion: 'api/v1',
  apiVersion2: 'api/v2',
  version: '2.3.0',
  site_name: 'Billennium',
  package: 'Standard',
  access_token:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZW1haWwiOiJhZG1pbkB4dGVuLXRlY2hub2xvZ3kuY29tIiwiZmlyc3RfbmFtZSI6ImFkbWluIiwibGFzdF9uYW1lIjoidGVzdCIsInJ1bGUiOiJhZG1pbiJ9.ILvt60BaJxNkAf31rhwg9g6eZ-yIYVeE9B0Nnw4WWes',
  beta: {
    apiUrl: 'http://192.168.1.33:8186',
    version1: 'api/v1',
    token:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoib3BlbkFQSS1UYWxhYWRUaGFpLWVuZXJneSJ9.nuvRJgnwfkZquFolTg0E3c3CV7nsQb-lcF5ZWZ_jboo',
  },
  api_url: {
    core: 'https://billennuim.xten-technology.com/core',
    fast: 'https://billennuim.xten-technology.com/customs',
  },
  api_version: {
    v1: 'api/v1',
    v2: 'api/v2',
  },
};
